export const wordsData = {
  "space": [
    "jupiter",
    "moon",
    "space",
    "comet",
    "meteors",
    "supernova",
    "galaxy",
    "planet",
    "sun",
    "saturn",
    "mercury",
    "nebula",
    "stars at night",
    "earth from space",
  ],
  "animals": [
    "red panda",
    "tiger",
    "jellyfish",
    "bird",
    "moth",
    "butterfly",
    "snake",
    "antelope",
    "crow",
    "fossa",
    "lion",
    "crane",
    "fish",
    "deer",
    "firelies",
    "cat",
    "magpie",
    "lemur",
    "fox",
    "shell",
    "feather",
    "wings",
    "flock",
  ],
  "people": [
    "child",
    "human",
    "traveller",
    "man",
    "woman",
  ],
  "human places": [
    "village",
    "town",
    "city",
    "gothic",
    "building",
    "observatory",
    "tower",
    "roof",
    "archway",
  ],
  "earth": [
    "plains",
    "mountains",
    "lake",
    "river",
    "stream",
    "desert",
    "water",
    "ocean",
    "cliff",
    "forest",
    "coast",
    "beach",
    "ice",
    "rocks",
    "opal",
    "jasper",
    "agate",
    "labradorite",
    "fossil",
    "ammonite",
    "moonstone",
    "crystal",
  ],
  "sky": [
    "sky",
    "rainbow",
    "cloud",
    "cumulus clouds",
    "mist",
    "fog",
    "snow",
    "shade",
    "rain",
    "storm",
    "smoke",
    "fire",
    "night",
    "sunset",
    "sunrise",
  ],
  "growing things": [
    "tree roots",
    "leaves",
    "vines",
    "boabab tree",
    "japanese maple tree",
    "moss",
    "branches",
    "ivy",
    "blossom tree",
    "mushrooms",
    "houseplant",
    "lily pads",
    "flowers",
  ],
  "objects": [
    "cloak",
    "books",
    "fractal",
    "gateway",
    "portal",
    "window",
    "mask",
    "music",
    "clock",
    "door",
    "boat",
    "sphere",
    "light",
    "lamp",
    "light ray",
    "hat",
    "path",
  ],
  "adjectives": [
    "distant",
    "huge",
    "fluorescent",
    "rocky",
    "bioluminescent",
    "mechanical",
    "magic",
    "cosmic",
    "dark",
    "red",
    "orange",
    "yellow",
    "green",
    "blue",
    "turquoise",
    "indigo",
    "purple",
    "pink",
    "brown",
    "gray",
  ],
  "verbs": [
    "watching",
    "running",
    "dancing",
    "embracing",
    "shining",
    "sleeping",
    "growing",
    "discovering",
    "resting",
    "playing",
    "hugging",
    "staring",
    "glowing",
    "flying",
  ],
};
